import React, { useState } from "react";
import Auth from "../../Auth";
import { Container } from "./styles";
import Utils from "../../Utils";
import Select from "react-select";

const defaultPrompt = `Below is an instruction that describes a task. Write a response that appropriately completes the request.

Write Writer's next reply in a fictional roleplay chat between User and Writer.
Writer is a bestselling author who is writing a scene for a novel.
### Instruction:

### Response:`;

const engines = [
  { value: "mancer/weaver", label: "mancer/weaver" },
  { value: "gpt-4.1", label: "gpt-4.1" },
];

const Playground = () => {
  const [prompt, setPrompt] = useState(defaultPrompt);
  const [temperature, setTemperature] = useState(0.85);
  const [frequencyPenalty, setFrequencyPenalty] = useState(0);
  const [presencePenalty, setPresencePenalty] = useState(0.2);
  const [completion, setCompletion] = useState("");
  const [seed, setSeed] = useState(null);
  const [engine, setEngine] = useState(engines[0]);

  const sendRequest = (e) => {
    e.preventDefault();
    setCompletion("Loading...");
    let started = false;

    Auth.streamWithIdToken(
      "/api/admin/inference",
      {
        prompt,
        temperature: parseFloat(temperature),
        frequency_penalty: parseFloat(frequencyPenalty),
        presence_penalty: parseFloat(presencePenalty),
        seed: parseInt(seed),
        engine: engine.value,
      },
      null,
      (chunk) => {
        if (chunk.text) {
          if (!started) {
            setCompletion(chunk.text);
            started = true;
          } else {
            setCompletion((prevCompletion) => prevCompletion + chunk.text);
          }
        }
        if (chunk.seed) {
          setSeed(chunk.seed);
        }
      },
      () => {}
    );
  };

  return (
    <Container>
      <div>
        <form onSubmit={sendRequest}>
          <label>
            Prompt:
            <br />
            <textarea
              value={prompt}
              onChange={(e) => setPrompt(e.target.value)}
              placeholder="Enter your prompt here"
            />
          </label>
          <label>
            Engine:
            <Select
              value={engine}
              onChange={(selectedOption) => setEngine(selectedOption)}
              options={engines}
            />
          </label>
          <label>
            Temperature:
            <input
              type="text"
              value={temperature}
              onChange={(e) => setTemperature(e.target.value)}
              placeholder="Enter temperature value"
            />
          </label>
          <label>
            Frequency Penalty:
            <input
              type="text"
              value={frequencyPenalty}
              onChange={(e) => setFrequencyPenalty(e.target.value)}
              placeholder="Enter frequency penalty value"
            />
          </label>
          <label>
            Presence Penalty:
            <input
              type="text"
              value={presencePenalty}
              onChange={(e) => setPresencePenalty(e.target.value)}
              placeholder="Enter presence penalty value"
            />
          </label>
          <label>
            Seed:
            <input
              type="text"
              value={seed}
              onChange={(e) => setSeed(e.target.value)}
              placeholder="Seed"
            />
          </label>
          <button>Submit</button>
        </form>
      </div>

      <div className="completion">{Utils.nl2br(completion)}</div>
    </Container>
  );
};

export default Playground;
